import { ExclamationCircleFilled } from '@ant-design/icons'
import classNames from 'classnames'
import type { ReactNode } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'

import cn from './AtomTextarea.module.scss'

const DEFAULT_ROWS = 4

type AtomTextareaProps = {
  id: string
  title: ReactNode
  registration: UseFormRegisterReturn
  error?: string
  placeholder?: string
  rows?: number
  required?: boolean
  isOrganisationSelected?: boolean
}

function AtomTextarea({
  id,
  title,
  registration,
  error,
  placeholder,
  rows = DEFAULT_ROWS,
  required = false,
  isOrganisationSelected = false,
}: AtomTextareaProps) {
  const errorId = `${id}-error`

  return (
    <div
      className={classNames(
        cn.textareaItem,
        isOrganisationSelected && cn.accentSelected
      )}
    >
      <label htmlFor={id} className={cn.label}>
        {title}
        {required && (
          <span className={cn.labelRequired} aria-hidden>
            *
          </span>
        )}
      </label>
      <textarea
        {...registration}
        id={id}
        rows={rows}
        placeholder={placeholder}
        aria-invalid={Boolean(error)}
        aria-describedby={errorId}
        className={classNames(cn.textarea, error && cn.textareaInvalid)}
      />
      <span
        id={errorId}
        role="alert"
        className={classNames(cn.error, !error && cn.hidden)}
      >
        {error && <ExclamationCircleFilled className={cn.errorIcon} />}
        {error}
      </span>
    </div>
  )
}

export default AtomTextarea
